// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper--na7L2","deliver":"deliver--mwtKJ","content":"content--lS4ZC"};